import { putResolve } from 'redux-saga/effects'
import _requestAddUserToGroup from 'store/sagas/requestAddUserToGroup'

export default function * requestAddUserToGroup (action) {
  const { userId, userGroupId } = action.payload

  yield putResolve(_requestAddUserToGroup({
    userId,
    userGroupId
  }))
}
